(function (window) {
  function createMjBannerKit(config) {
    config = config || {};
    return {
      index: 0,
      progress: 0,
      paused: false,
      autoPlay: config.play !== false,
      imageMs: Number(config.ms) || 4000,
      count: Number(config.count) || 1,
      startedAt: 0,
      remaining: 0,
      timer: null,
      startX: 0,
      startY: 0,
      init: function () {
        var self = this;
        this.remaining = this.imageMs;
        this.startedAt = performance.now();
        if (this.$nextTick) this.$nextTick(function () { self.syncVideos(); });
        this.timer = window.setInterval(function () { self.tick(); }, 50);
      },
      destroy: function () {
        if (this.timer) window.clearInterval(this.timer);
      },
      slideEls: function () {
        return this.$refs && this.$refs.track ? Array.from(this.$refs.track.children) : [];
      },
      visibleVideo: function () {
        var slide = this.slideEls()[this.index];
        if (!slide) return null;
        return (
          Array.from(slide.querySelectorAll('video')).find(function (video) {
            var style = window.getComputedStyle(video);
            if (style.display === 'none' || style.visibility === 'hidden') return false;
            var parent = video.parentElement;
            while (parent && parent !== slide) {
              if (window.getComputedStyle(parent).display === 'none') return false;
              parent = parent.parentElement;
            }
            return true;
          }) || null
        );
      },
      syncVideos: function () {
        var active = this.visibleVideo();
        this.slideEls().forEach(function (slide) {
          slide.querySelectorAll('video').forEach(function (video) {
            if (video === active) return;
            try {
              video.pause();
            } catch (error) {
              /* ignore */
            }
          });
        });
        if (!active) return;
        active.loop = false;
        active.muted = true;
        try {
          active.currentTime = 0;
        } catch (error) {
          /* ignore */
        }
        if (active.play) active.play().catch(function () {});
      },
      goTo: function (nextIndex) {
        if (this.count < 2) return;
        this.index = (nextIndex + this.count) % this.count;
        this.progress = 0;
        this.startedAt = performance.now();
        this.remaining = this.imageMs;
        this.syncVideos();
      },
      goNext: function () {
        this.goTo(this.index + 1);
      },
      goPrev: function () {
        this.goTo(this.index - 1);
      },
      onSwipeStart: function (event) {
        var point = event.changedTouches ? event.changedTouches[0] : event;
        this.startX = point.clientX;
        this.startY = point.clientY;
      },
      onSwipeEnd: function (event) {
        if (this.count < 2) return;
        var point = event.changedTouches ? event.changedTouches[0] : event;
        var dx = point.clientX - this.startX;
        var dy = point.clientY - this.startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) this.goNext();
        else this.goPrev();
      },
      tick: function () {
        if (this.paused || !this.autoPlay || this.count < 2) return;
        var video = this.visibleVideo();
        if (video && video.duration > 0.2 && Number.isFinite(video.duration) && video.currentTime > 0.05) {
          this.progress = Math.min(100, (video.currentTime / video.duration) * 100);
          if (video.ended || video.currentTime >= video.duration - 0.08) this.goNext();
          return;
        }
        var elapsed = performance.now() - this.startedAt;
        this.progress = Math.min(100, (elapsed / this.remaining) * 100);
        if (elapsed >= this.remaining) this.goNext();
      },
      pause: function () {
        if (window.innerWidth < 768) return;
        this.paused = true;
        this.remaining = Math.max(200, this.remaining - (performance.now() - this.startedAt));
        var video = this.visibleVideo();
        if (video) {
          try {
            video.pause();
          } catch (error) {
            /* ignore */
          }
        }
      },
      resume: function () {
        if (window.innerWidth < 768) return;
        this.paused = false;
        this.startedAt = performance.now();
        var video = this.visibleVideo();
        if (video && video.play) video.play().catch(function () {});
      },
    };
  }

  window.mjBannerKit = createMjBannerKit;

  document.addEventListener('alpine:init', function () {
    if (window.Alpine && typeof window.Alpine.data === 'function') {
      window.Alpine.data('mjBannerKit', createMjBannerKit);
    }
  });
})(window);
